import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../../constants/routes";
import {
  AdminEventOrganizerService,
  AuthService,
  CountryService,
} from "../../../services";
import {
  addDefaultImg,
  handleConsoleError,
} from "../../../utils/common-methods";
import { globalConstant } from "../../../constants/globalConstant";
import Swal from "sweetalert2";
import { getStateList } from "../../../services/StateService";

function EditEventOrganizerProfile(props) {
  const location = useLocation();
  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [isactive, setIsActive] = useState(false);

  const [validated, setValidated] = useState(false);

  const [businessProfileData, setBusinessProfile] = useState({});
  const [personalProfileData, setPersonalProfile] = useState({});
  const [subscriptionPlanData, setSubscriptionPlan] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [countryId, setCountry] = useState("");
  const [stateId, setState] = useState("");

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    var personalProfile = personalProfileData;
    let countryIndex = countries.findIndex(
      (country) => country.id === personalProfile?.countryId
    );
    if (countryIndex >= 0) {
      personalProfile.countryName = countries[countryIndex]?.countryName;
    }

    let stateIndex = states.findIndex(
      (state) => state.id === personalProfile.stateId
    );
    if (stateIndex >= 0) {
      personalProfile.stateName = states[stateIndex]?.stateName;
    }
    setPersonalProfile(personalProfile);
  }, [states, countries]);

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);

  const handleAdd = async (e) => {
    setId("");
    setName("");
    setIsActive(false);
    handleShow();
    setError("");
  };

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await AdminEventOrganizerService.getOrganizerById(
        location.state?.profile.id
      );
      if (res?.isSuccess) {
        await getCountryList();
        await getStatesList();
        setBusinessProfile(res?.data?.businessProfile);
        setPersonalProfile(res?.data?.personalProfile);
        setSubscriptionPlan(res?.data?.subscriptionPlan);
        setCountry(res?.data?.businessProfile?.countryId);
        setState(res?.data?.businessProfile?.stateId);

        props.application.setLoading(false);
      } else {
       // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
      toast.error(error?.message||message);
    }
  };

  const getCountryList = async () => {
    props.application.setLoading(true);

    try {
      const res = await CountryService.getCountryList();
      if (res?.isSuccess) {
        setCountries(res?.data ?? []);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const getStatesList = async () => {
    props.application.setLoading(true);

    try {
      const res = await getStateList();
      if (res?.isSuccess) {
        setStates(res?.data ?? []);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    setValidated(true);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    try {
      props.application.setLoading(true);
      const data = {
        id: businessProfileData?.id,
        businessName: businessProfileData?.businessName,
        leagalBusinessName: businessProfileData?.leagalBusinessName,
        contactlegalname: businessProfileData?.contactlegalname,
        contactpreferredname: businessProfileData?.contactpreferredname,
        countryId: countryId,
        address: businessProfileData?.address,
        city: businessProfileData?.city,
        stateId: stateId,
        zipCode: businessProfileData?.zipCode,
        email: businessProfileData?.email,
        phone: businessProfileData?.phone,
        website: businessProfileData?.website,
        numberofemployees: businessProfileData?.numberofemployees,
        description: businessProfileData?.description,
        currencyId: businessProfileData?.currencyId,
        businessRegistrationNumber:
          businessProfileData?.businessRegistrationNumber,
        vatNumber: businessProfileData?.vatNumber,
        commissionPercentage:
          businessProfileData?.commissionPercentage ??
          subscriptionPlanData?.commissionPercentage,
      };
      const res = await AdminEventOrganizerService.updateProfile(data);
      if (res?.isSuccess) {
        props.application.setLoading(false);
        toast.success(res?.message);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
      await getData();
    } catch (err) {
      props.application.setLoading(false);
      const message = handleConsoleError(err);
      toast.error(err?.message || message);
    }
  };

  const handleReject = () => {
    const pinkColor = globalConstant.COLOR_PINK;
    Swal.fire({
      title: "Confirmation",
      text: `Are you sure you want to ${
        businessProfileData?.isActive ? "reject" : "approve"
      } this profile?`,
      showCancelButton: true,
      confirmButtonColor: pinkColor,
      cancelButtonColor: "#373737",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        // handleProfileApproval
        props.application.setLoading(true);
        const res = await AdminEventOrganizerService.handleProfileApproval({
          businessId: businessProfileData?.id,
          isApproved: !businessProfileData?.isActive,
        });
        if (res?.isSuccess) {
          props.application.setLoading(false);
          toast.success(res?.message);
          await getData();
        } else {
          toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          props.application.setLoading(false);
        }
      }
    });
  };

  const handleResetPassword = () => {
    props.application.setLoading(true);
    AuthService.ForgotPassword({ email: businessProfileData?.email })
      .then((response) => {
        props.application.setLoading(false);
        if (response?.isSuccess) {
          toast.success(response?.message);
        } else {
          toast.error(response?.message ||response?.Errors?.[0]?.Message || "Something went wrong");
        }
      })
      .catch((error) => {
        props.application.setLoading(false);
        const message = handleConsoleError(error);
        toast.error(error?.message|| message);
      });
  };

  return (
    <React.Fragment>
      <div
        className="pagetitle"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to={routes.ADMIN_EVENT_ORGANIZER_LIST}>
                Event Organisers
              </Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Edit
            </li>
          </ol>
        </nav>
        <div style={{ display: "flex" }}>
          <div className="verifier-buttton">
            <Button variant="info" onClick={handleAdd}>
              View Personal Details
            </Button>{" "}
          </div>
          <div className="verifier-buttton">
            <Button variant="warning" onClick={handleResetPassword}>
              Reset Password
            </Button>{" "}
          </div>
          <div className="verifier-buttton">
            <Button
              variant={businessProfileData?.isActive ? "danger" : "info"}
              onClick={handleReject}
            >
              {businessProfileData?.isActive ? "Reject" : "Approve"}
            </Button>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Personal details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form aria-disabled="true" style={{ flex: 1 }}>
            <fieldset disabled>
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>First name</Form.Label>
                  <Form.Control defaultValue={personalProfileData?.firstName} />
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>Last name</Form.Label>
                  <Form.Control defaultValue={personalProfileData?.lastName} />
                </Form.Group>
              </Row>

              <Form.Group controlId="formGridPassword">
                <Form.Label>Email</Form.Label>
                <Form.Control defaultValue={personalProfileData?.email} />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Phone</Form.Label>
                <Form.Control defaultValue={personalProfileData?.phone} />
              </Form.Group>
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Gender</Form.Label>
                  <Form.Control
                    defaultValue={
                      personalProfileData?.gender === "M" ? "Male" : "Female"
                    }
                    placeholder=""
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridPassword">
                  <Form.Label>Birthday</Form.Label>
                  <Form.Control defaultValue={personalProfileData?.birthday} />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    defaultValue={personalProfileData?.countryName ?? ""}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Street address</Form.Label>
                  <Form.Control
                    defaultValue={personalProfileData?.streetAddress}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>City</Form.Label>
                  <Form.Control defaultValue={personalProfileData?.city} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Country</Form.Label>
                  <Form.Control defaultValue={personalProfileData?.stateName} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Zip/Postal Code</Form.Label>
                  <Form.Control
                    defaultValue={personalProfileData?.postalCode}
                  />
                </Form.Group>
              </Row>

              <Form.Group className="mb-3" controlId="formGridAddress1">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  disabled
                  defaultValue={personalProfileData?.description}
                />
              </Form.Group>
            </fieldset>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="table-responsive">
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            columnGap: 20,
            overflow: "hidden",
            marginBottom: 10,
          }}
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            style={{ flex: 1 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: 25,
                  border: "3px solid #ec2e7a",
                  overflow: "hidden",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ width: 44, height: 44 }}
                  alt=""
                  src={
                    location.state?.profile?.businessLogoUrl ??
                    "/assets/images/users/user-dummy-img.jpg"
                  }
                ></img>
              </div>

              <h2>Business details </h2>
            </div>
            <Row className="mb-3">
              <p>Organiser Profile</p>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridBasics">
                <Form.Label>Business Name</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.businessName}
                  required
                  placeholder="Enter business name"
                  onChange={(e) => {
                    businessProfileData.businessName = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Business name is required
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPassword">
                <Form.Label>Legal Business Name</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.leagalBusinessName}
                  required
                  placeholder="Enter legal business name"
                  onChange={(e) => {
                    businessProfileData.leagalBusinessName = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Legal business name is required
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridPassword">
                <Form.Label>Contact Legal Name</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.contactlegalname}
                  placeholder="Enter contact legal name"
                  onChange={(e) => {
                    businessProfileData.contactlegalname = e.target.value;
                  }}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridPassword">
                <Form.Label>Contact Preferred Name</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.contactpreferredname}
                  placeholder="Enter contact preferred name"
                  onChange={(e) => {
                    businessProfileData.contactpreferredname = e.target.value;
                  }}
                />
              </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formGridAddress1">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                defaultValue={businessProfileData?.description}
                placeholder="Enter business description"
                onChange={(e) => {
                  businessProfileData.description = e.target.value;
                }}
              />
            </Form.Group>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>State</Form.Label>
                <Form.Select
                  value={countryId}
                  onChange={(e) => {
                    setCountry(e.target.value);
                  }}
                  placeholder="Select"
                  required
                  aria-label="default"
                >
                  {countries.map((country) => {
                    return (
                      <option value={country?.id}>{country?.countryName}</option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>Street address</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.address}
                  required
                  placeholder="1234 Main St"
                  onChange={(e) => {
                    businessProfileData.address = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Street address is required
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>City</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.city}
                  required
                  placeholder="1234 Main St"
                  onChange={(e) => {
                    businessProfileData.city = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  City is required
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>Country</Form.Label>
                <Form.Select
                  value={stateId}
                  onChange={(e) => {
                    setState(e.target.value);
                  }}
                  required
                  aria-label="default"
                >
                  {states.map((state) => {
                    return <option value={state?.id}>{state?.stateName}</option>;
                  })}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>Zip/Postal Code</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.zipCode}
                  required
                  placeholder=""
                  onChange={(e) => {
                    businessProfileData.zipCode = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Zip/Postal code is required
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.email}
                  required
                  type="email"
                  placeholder="Enter email"
                  onChange={(e) => {
                    businessProfileData.email = e.target.value;
                  }}
                  readOnly
                  disabled
                />
                <Form.Control.Feedback type="invalid">
                  Email is required
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPhone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.phone}
                  required
                  type="Number"
                  placeholder="Enter phone number"
                  onChange={(e) => {
                    businessProfileData.phone = e.target.value;
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Phone number is required
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Website</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.website}
                  placeholder="Enter website"
                  onChange={(e) => {
                    businessProfileData.website = e.target.value;
                  }}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridPhone">
                <Form.Label>Number Of Employees</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.numberofemployees}
                  type="Number"
                  placeholder="Enter number of employees"
                  onChange={(e) => {
                    businessProfileData.numberofemployees = e.target.value;
                  }}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Vat Number</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.vatNumber}
                  placeholder="Enter Vat Number"
                  onChange={(e) => {
                    businessProfileData.vatNumber = e.target.value;
                  }}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Business Registration Number</Form.Label>
                <Form.Control
                  defaultValue={businessProfileData?.businessRegistrationNumber}
                  placeholder="Enter Business Registration Number"
                  onChange={(e) => {
                    businessProfileData.businessRegistrationNumber =
                      e.target.value;
                  }}
                />
              </Form.Group>
              {/* <Form.Control.Feedback type="invalid">
                Business Registration Number is required
              </Form.Control.Feedback> */}
            </Row>
            {subscriptionPlanData && (
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label>Current Subscription</Form.Label>
                  <Form.Control
                    defaultValue={subscriptionPlanData?.subscriptionPlanName}
                    disabled
                  />
                </Form.Group>
                <Form.Group
                  as={Col}
                  style={{ marginBottom: 20 }}
                  controlId="formGridCommision"
                >
                  <Form.Label>Commission rate (%)</Form.Label>
                  <Form.Control
                    defaultValue={subscriptionPlanData?.commissionPercentage}
                    required
                    type="Number"
                    step={0.01}
                    placeholder="Enter commission rate"
                    onChange={(e) => {
                      businessProfileData.commissionPercentage = e.target.value;
                    }}
                  />
                </Form.Group>
              </Row>
            )}

            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
          <Form style={{ flex: 1, maxWidth: "50%" }}>
            <div style={{}}>
              <h2>Cover picture</h2>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                columnGap: 20,
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  border: "1px solid #ec2f7c",
                  borderRadius: 5,
                  marginTop: 10,
                  position: "relative",
                }}
              >
                <div style={{ padding: 10 }}>
                  <img
                    style={{ minWidth: 150, minHeight: 150, height: 150 }}
                    src={businessProfileData?.coverPicWide}
                    alt=""
                    onError={addDefaultImg}
                  ></img>
                </div>
                <div
                  style={{
                    position: "absolute",
                    height: 30,
                    backgroundColor: "#ec2f7c",
                    textAlign: "center",
                    padding: 5,
                    bottom: 20,
                  }}
                >
                  <span style={{ color: "white" }}>
                    {"Cover picture - Wide"}
                  </span>
                </div>
              </div>
              <div
                style={{
                  textAlign: "center",
                  border: "1px solid #ec2f7c",
                  borderRadius: 5,
                  marginTop: 10,
                  position: "relative",
                }}
              >
                <div style={{ padding: 10 }}>
                  <img
                    style={{ minWidth: 150, minHeight: 150, height: 150 }}
                    src={businessProfileData?.coverPicSmall}
                    alt=""
                    onError={addDefaultImg}
                  ></img>
                </div>
                <div
                  style={{
                    position: "absolute",
                    height: 30,
                    backgroundColor: "#ec2f7c",
                    textAlign: "center",
                    padding: 5,
                    bottom: 20,
                  }}
                >
                  <span style={{ color: "white" }}>
                    {"Cover picture - Square"}
                  </span>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", columnGap: 20 }}>
              {(businessProfileData?.documents ?? []).length > 0 && (
                <div>
                  <div style={{ marginTop: 20 }}>
                    <h2>Documents</h2>
                  </div>
                  <div
                    style={{ display: "flex", columnGap: 20, flexWrap: "wrap" }}
                  >
                    {businessProfileData.documents.map((document, index) => (
                      <Link key={index} to={document?.docsUrl} target="_blank">
                        <div
                          style={{
                            textAlign: "center",
                            border: "1px solid #ec2f7c",
                            borderRadius: 5,
                            minWidth: 150,
                            marginTop: 10,
                          }}
                        >
                          <div style={{ height: "70%", padding: 10 }}>
                            <img
                              style={{ width: 50, height: 50 }}
                              src="/assets/images/svg/filetype-pdf.svg"
                              alt=""
                            ></img>
                          </div>
                          <div
                            style={{
                              height: "30%",
                              backgroundColor: "#ec2f7c",
                              textAlign: "center",
                              padding: 5,
                            }}
                          >
                            <span style={{ color: "white" }}>
                              {document?.docsType}
                            </span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {(businessProfileData?.images ?? []).length > 0 && (
                <div>
                  <div style={{ marginTop: 20 }}>
                    <h2>Pictures</h2>
                  </div>
                  <div
                    style={{ display: "flex", columnGap: 20, flexWrap: "wrap" }}
                  >
                    {businessProfileData?.images.map((image, index) => (
                      <Link key={index} to={image?.imageUrls} target="_blank">
                        <div
                          style={{
                            textAlign: "center",
                            border: "1px solid #ec2f7c",
                            borderRadius: 5,
                            minWidth: 100,
                            maxWidth: 150,
                            marginTop: 10,
                          }}
                        >
                          <div style={{ height: "70%", padding: 10 }}>
                            <img
                              style={{ width: 50, height: 50 }}
                              src={image?.imageUrls}
                              alt=""
                              onError={addDefaultImg}
                            ></img>
                          </div>
                          <div
                            style={{
                              height: "30%",
                              backgroundColor: "#ec2f7c",
                              textAlign: "center",
                              padding: 5,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <span style={{ color: "white" }}>
                              {image?.imageId}
                            </span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(
  EditEventOrganizerProfile
);
